// A plane's `locations` array can list the same city more than once (e.g. once per
// edge_location), so counts shown to the user dedupe by city name -- matching how the
// region tree itself dedupes cities under each country.
export const countUniqueCities = (locations) => {
    const cities = new Set();
    (locations || []).forEach(region => {
        if (region?.city) cities.add(region.city);
    });
    return cities.size;
};

// The product-level region count sums the union of cities across all enabled planes,
// not a per-plane sum -- a city present in both control and data plane locations
// (typical for management endpoints) should only count once toward the product total.
export const countUniqueCitiesAcrossPlanes = (enabledPlanes) => {
    const cities = new Set();
    (enabledPlanes || []).forEach(([, planeData]) => {
        (planeData?.locations || []).forEach(region => {
            if (region?.city) cities.add(region.city);
        });
    });
    return cities.size;
};

// `selectedByPlane` is an array of `[planeType, selectedRegions]` pairs (the same shape
// `enabledPlanes` uses), where each `selectedRegions` is a plane's raw `city-*` leaf
// values from the region TreeSelect (see useRegionTreeItems) -- not `Region` objects, so
// this dedupes by stripping the prefix rather than reading a `.city` field. Mirrors
// `countUniqueCitiesAcrossPlanes`: a city selected in both control and data plane only
// counts once toward the product-level "N Regions" badge.
export const countSelectedRegions = (selectedByPlane) => {
    const cities = new Set();
    (selectedByPlane || []).forEach(([, selectedRegions]) => {
        (selectedRegions || []).forEach(value => {
            if (typeof value === 'string' && value.startsWith('city-')) {
                cities.add(value.slice('city-'.length));
            }
        });
    });
    return cities.size;
};
